import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from 'axios';
import { changeUserAuthStatus } from '../../../DataStore/actions/searchFormActions';
import './css/UserMenu.css';
import { USER_PROFILE, EXIT } from '../../../Utils/Constants/GlobalConstants';

const mapStateToProps = (state) => ({ ...state });

class UserMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleExitClick = () => {
    const {
      changeUserAuthStatus: changeUserAuthStatusAction,
      location,
      navigate,
    } = this.props;
    axios.post('/api/auth/signoff').then(() => {
      window.localStorage.removeItem('accessToken');
      window.localStorage.removeItem('email');
      window.localStorage.setItem('isUserLoggedIn', false);
      changeUserAuthStatusAction(false);

      if (location.pathname === '/profile') {
        navigate('/');
      }
    });
  };

  render() {
    return (
      <div className="user_menu_w">
        <Link to="/profile" className="user_menu_item br_text_18">
          {USER_PROFILE}
        </Link>

        <button
          type="button"
          className="user_menu_item br_text_18"
          onClick={this.handleExitClick}
        >
          {EXIT}
        </button>
      </div>
    );
  }
}

UserMenu.propTypes = {
  changeUserAuthStatus: PropTypes.func.isRequired,
  location: PropTypes.instanceOf(Object).isRequired,
  navigate: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, { changeUserAuthStatus })(UserMenu);
